import { createLogger } from 'libs/end-to-end/src/isomorphic-logger';
import { useEffect } from 'react';
import { useUser } from 'apps/sigma2-ui/src/state/user';
import { useNavigateSafe } from 'apps/sigma2-ui/src/lib/hooks/useNavigateSafe';

const logger = createLogger({ name: 'useAuthenticatedPageRedirect' });

export const useAuthenticatedPageRedirect = () => {
  const { myUser, myUserStatus, logoutLink } = useUser();
  const navigate = useNavigateSafe();

  // TODO: The complexity of this code is greater than 10. Refer to https://eslint.org/docs/latest/rules/complexity
  // Set isAlive to false when the component unmounts.
  useEffect(() => {
    if (!myUserStatus || myUserStatus === 'logging_in') {
      return;
    }

    if (myUserStatus === 'logging_out' && logoutLink) {
      logger.debug('Redirecting to logout link', logoutLink);
      window.location.replace(logoutLink);
      return;
    }

    if (myUserStatus === 'logged_out' || !myUser) {
      logger.debug('Logged out. Redirecting home.');
      navigate('/');
      return;
    }
  }, [myUserStatus, myUser, navigate, logoutLink]);
};
